import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import { DOWNSCALE_FACTOR } from 'src/conf/scale';

export default class LeaderboardsTab extends ButtonScaleView {
  public get label() {
    return this._label.localeText?.() ?? '';
  }

  public set label(v: string) {
    this._label.localeText = () => i18n(v);
  }
  private readonly _label: LangBitmapFontTextView;

  public get active() {
    return this._active;
  }

  public set active(v: boolean) {
    this._active = v;
    this.updateButtonImages({
      image: `assets/ui/weeklyLeaderboard/popups/popupLeaderboards/leaderboards_tab${v ? '_active' : ''}.png`,
    });
    this.updateOpts({
      // The disabled image looks slight off center, so we need to adjust the offset
      offsetY: !v ? 2 : 0,
    });
    this._label.updateOpts({
      color: v ? '#FFFFFF' : '#8D6724',
      font: v ? 'Title' : 'Body',
    });
  }
  private _active = false;

  constructor(opts: ButtonScaleViewOpts) {
    super({
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/leaderboards_tab.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      imgScale: DOWNSCALE_FACTOR,
      ...opts,
    });

    const padding = 30;
    this._label = new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      size: 26,
      color: '#814352',
      align: 'center',
      verticalAlign: 'center',
      x: padding / 2,
      y: -2,
      width: -padding + (opts.width ?? 0),
      height: opts.height,
      localeText: () => '[Label]',
    });
  }
}
